import { render, staticRenderFns } from "./DocumentsAndVideos.vue?vue&type=template&id=57c94894&"
import script from "./DocumentsAndVideos.vue?vue&type=script&lang=js&"
export * from "./DocumentsAndVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports